module.exports = __webpack_public_path__ + "static/media/more.3364907b.svg";